module.exports = __webpack_public_path__ + "img/convergists4.2390e0ad.png";